<template>
    <form method="POST" enctype="multipart/form-data" action="/admin/statistics/purchases_horizon/excel">
        <input type="hidden" name="_token" value="" id="form_token">
        <div class="row">
            <div class="col-md-9">
                <date-range-picker></date-range-picker>
                <div class="form-group clearfix">
                    <div class="col-md-6">
                        <label>Период реакции</label>
                        <input type="number" name="reaction" v-model="reaction" id="reaction" class="form-control">
                    </div>
                    <div class="col-md-6">
                        <label>Горизонт прогноза</label>
                        <input type="number" name="horizon" v-model="horizon" id="horizon" class="form-control">
                    </div>
                </div>
                <div class="form-group clearfix">
                    <div class="col-md-12">
                        <label style="font-size: 15px">
                            <input name="is_show_hollow_products" v-model="is_show_hollow_products" @change="selectAllBrands()" type="checkbox">
                            Показывать упаковки которые не продавались
                        </label>
                    </div>
                </div>
                <div class="form-group">
                    <div>
                        <input
                                v-for="status in statuses"
                                type="hidden"
                                name="statuses[]"
                                :value="status">
                        <input
                                v-for="column in columns"
                                type="hidden"
                                :name="'columns[' + column.code + ']'"
                                :value="column.title"
                        >
                    </div>
                </div>
                <div class="col-md-12">
                    <label style="font-size: 15px">
                        <input v-model="is_chosen_all_brands" @change="selectAllBrands()" type="checkbox">
                        Выбрать всё
                    </label>
                </div>
                <br>
                <div class="col-md-2" style="height: 44px" v-for="brand in brands">
                    <div class="form-group">
                        <label>
                            <input type="checkbox" name="brands[]" :value="brand.code" v-model="chosen_brands">
                            {{ brand.title }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-3" style="margin-top: 24px">
                <div class="form-group">
                    <div class="btn btn-primary form-control" @click="load" >
                        <i v-show="is_loading" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        <span v-show="!is_loading">
                            <i class="fa fa-file-excel-o"></i>
                            Выгрузить данные
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success form-control">
                        <i class="fa fa-file-excel-o"></i>
                        Сохранить в Excel
                    </button>
                </div>
                <div class="form-group">
                    <label>Поставщик</label>
                    <select class="form-control" name="supplier" id="supplier" v-model="supplier">
                        <option v-for="supplier_item in suppliers"
                                :value="supplier_item.id"
                        >{{ supplier_item.title }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Файл от поставщика</label>
                    <input name="file" type="file" id="file" ref="myFiles" class="custom-file-input"
                           @change="previewFiles()">
                </div>
            </div>
        </div>
        <br><br>
        <div class="row" v-show="products.length">
            <div class="col-md-12">
                <h3>Всего товаров: {{ products.length }}</h3>
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th v-for="column in columns">{{ column.title }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(product, key) in products">
                        <td><b>{{ key + 1 }}.</b></td>
                        <td v-for="column in columns">{{ product[column.code] }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['statuses', 'brands', 'suppliers'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
            document.querySelector('#form_token').value = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            let columns = [
                { code: 'name', title: 'Название' },
                { code: 'short_title', title: 'Производитель' },
                { code: 'title', title: 'Упаковка' },
                { code: 'order_point_value', title: 'Значение точки заказа' },
                { code: 'min_safety_stock', title: 'Минимальный страховой запас' },
                { code: 'stock_balance', title: 'Остаток на складе' },
                { code: 'recommend_purchase', title: 'Рекомендуемый объем закупки' },
                { code: 'security_ration', title: 'Коэффициент обеспеченности' },
                { code: 'supplier_available_quantity', title: 'Доступно у поставщика' },
            ];

            return {
                form_data: new FormData(),
                columns: columns,
                products: [],
                is_loading: false,
                date_start: '',
                date_finish: '',
                supplier: null,
                horizon: 1,
                reaction: 1,
                chosen_brands: this.getCodes(this.brands),
                is_chosen_all_brands: true,
                is_show_hollow_products: true,
            };
        },
        methods: {
            previewFiles() {
                this.files = this.$refs.myFiles.files[0];
            },
            getCodes: function (arr) {
                let codes = [];

                arr.forEach(function (item) {
                    codes.push(item.code);
                });

                return codes;
            },
            load: function () {
                if (!this.checkEnteredData()) {
                    alert('Заполните обязательные поля!');
                    return;
                }

                let formsData = new FormData();

                this.statuses.forEach(status => {
                    formsData.append('statuses[]', status);
                });

                this.chosen_brands.forEach(brand => {
                    formsData.append('brands[]', brand);
                });

                let columns = this.getNormalizedArr(this.columns, 'code', 'title');
                Object.keys(columns).forEach(column => {
                    formsData.append('columns[' + column +']', columns[column])
                });

                formsData.append('supplier', this.supplier);
                formsData.append('is_show_hollow_products', this.is_show_hollow_products);

                if(this.files) {
                    formsData.append('file', this.files, this.files.name);
                }

                if(this.date_start && this.date_finish) {
                    formsData.append('date_start', this.date_start);
                    formsData.append('date_finish', this.date_finish);
                }

                if(this.reaction && this.horizon) {
                    formsData.append('reaction', this.reaction);
                    formsData.append('horizon', this.horizon);
                }
                console.log(this.formsData);

                let self = this;
                this.is_loading = true;
                this.$http.post(
                    '/statistics/purchases_horizon/get', formsData
                ).then(function (response) {
                    self.is_loading = false;
                    self.products = self.is_show_hollow_products === true
                        ? response.data
                        : response.data.filter(product => product.order_point_value != null);
                }, function (response) {
                    this.show_loader = false;

                    let errors = '';
                    for (let field in response.data.errors) {
                        errors += response.data.errors[field] + '\r\n';
                    }

                    alert(errors);
                });
            },
            getNormalizedArr: function (arr, key, value) {
                let columns = {};
                arr.forEach(function (item) {
                    columns[item[key]] = item[value];
                });

                return columns;
            },
            checkEnteredData: function () {
                return this.chosen_brands.length && (this.date_start && this.date_finish && this.reaction && this.horizon);
            },
            selectAllBrands: function () {
                this.is_chosen_all_brands ? this.chosen_brands = this.getCodes(this.brands) : this.chosen_brands = [];
            },
        },
        created: function () {
            this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
        }
    };
</script>
